<template>
  <div>
    <el-dialog
      :title="`使用模板“${formData.name}”的${typeName}`"
      width="800px"
      class="my-dialog-template"
      custom-class="custom-btn"
      :visible.sync="visible"
      top="0"
    >
      <div class="tools-box">
        <el-button class="org-btn small" @click="addUser">添加{{ typeName }}</el-button>
      </div>
      <el-table :data="tableData" style="width: 100%" border class="list-table" v-loading="listLoading" tooltip-effect="dark">
        <el-table-column property="shortName" :label="typeName + '名称'" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.shortName || scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="formData.type == 2" property="mechanName" label="所属团队" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.mechanName }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="formData.type == 1" property="useStatus" label="团队状态" width="130">
          <template slot-scope="scope">
            <span>{{ all.ENABLE[scope.row.useStatus] }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="formData.type == 1" property="toucherName" label="联系人" width="130" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
      <el-pagination
        v-if="tableData.length > 0"
        class="page"
        @size-change="
          pageNum = 1;
          pageSize = $event;
          getList();
        "
        :pager-count="5"
        :current-page.sync="pageNum"
        :page-size.sync="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="getList()"
        :total="total"
      >
      </el-pagination>
    </el-dialog>
    <!-- 新增使用团队 -->
    <addUser
      ref="addUser"
      @reload="
        searchAjax();
        $emit('reload');
      "
    ></addUser>
  </div>
</template>
<script>
import { pageTool } from '@/api/mixins'
import addUser from "./addUser";
export default {
  mixins: [pageTool],
  components: { addUser },
  data: () => ({
    visible: false,
    productsId: [],
    all: {},
    formData: {},
  }),
  computed: {
    typeName() {
      return this.formData.type == '1' ? '团队' : '业务员'
    }
  },
  created() {
    this.$tools.getall((data) => {
      this.all = data;
    });
  },
  methods: {
    open(data) {
      console.log(data)
      this.formData = JSON.parse(JSON.stringify(data))
      this.visible = true
      this.searchParams.commissonTemplateCode = this.formData.code;
      if (data.type != 1) {
        this.searchParams.isShow = '1';
      }
      this.initListAjax(data.type == 1 ? '/master/commissonTemplate/queryMechanList' : '/master/mechanUser/queryList');
    },
    // 新增使用团队
    addUser() {
      this.$refs.addUser.open(this.formData);
    },
    del(item) {
      this.$confirm(`<p class="text">删除后，该${this.typeName}将不再应用任何模板，是否删除？</p><p class="info-text">注：删除不会改变团队现在的费率</p>`, '', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        customClass: "new-confirm",
        dangerouslyUseHTMLString: true
      }).then(() => {
        let params = {
          templateId: this.formData.id,
        }
        // if (this.formData.type == 1) {
        params.mechanId = item.id
        // } else {
        //   params.userId = item.id
        // }
        this.$http({
          url: '/master/commissonTemplate/deleteMechan',
          type: 'DELETE',
          params: params,
        }).then(res => {
          this.$message.success("删除成功");
          this.searchAjax();
          this.$emit('reload');
        })
      });
    },
  },
}
</script>
<style lang='scss' scoped>
.my-dialog-template /deep/ {
  display: flex;
  align-items: center;
  .el-dialog {
    margin-top: 0;
    margin-bottom: 0;
  }
  .el-dialog__body {
    padding-top: 0;
  }
  .tools-box {
    text-align: right;
    margin-bottom: 15px;
  }
}
</style>